/* Money formatting. Base/checkout currency is ALL (Albanian Lek); EUR is a reference computed with the
   admin-set exchange rate (ALL per 1 EUR) that the backend exposes in /api/store/config. */
const FX = { EUR: 98.5 };
export const setFx = (fx) => {
  if (!fx) return;
  Object.entries(fx).forEach(([k, v]) => {
    const n = Number(v);
    if (n > 0) FX[k] = n;
  });
};
export const getFx = (ccy = "EUR") => FX[ccy];

const nf0 = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
const nf2 = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const num = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
};

/** "45,000 L" — Lek amounts are shown without decimals unless they carry cents. */
export const formatALL = (v) => {
  const n = num(v);
  if (n === null) return "—";
  return `${Number.isInteger(n) ? nf0.format(n) : nf2.format(n)}\u00a0L`;
};
/** "€457" (whole euros) or "€457.20" when a precise amount is required. */
export const formatEUR = (v, exact = false) => {
  const n = num(v);
  if (n === null) return "—";
  return `€${exact ? nf2.format(n) : nf0.format(Math.round(n))}`;
};
export const toEur = (all) => {
  const n = num(all);
  return n === null ? null : n / FX.EUR;
};
export const toAll = (eur) => {
  const n = num(eur);
  return n === null ? null : n * FX.EUR;
};

export const money = (v, currency = "ALL", compact = true) => {
  if (currency === "ALL") return formatALL(v);
  if (currency === "EUR") return formatEUR(v, !compact);
  const n = num(v);
  if (n === null) return "—";
  try {
    return new Intl.NumberFormat("en-IE", { style: "currency", currency }).format(n);
  } catch {
    return `${currency} ${n.toFixed(2)}`;
  }
};

/** Primary storefront price (ALL). */
export const price = (v) => formatALL(v);
/** EUR reference for an ALL amount: "≈ €457". */
export const refPrice = (v) => {
  const e = toEur(v);
  return e === null ? "" : `≈ ${formatEUR(e)}`;
};

export const dateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const dateOnly = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const titleCase = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
